"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stakeBanxNft = void 0;
const constants_1 = require("../../../constants");
const helpers_1 = require("../../../helpers");
const anchor_1 = require("@project-serum/anchor");
const token_1 = require("@project-serum/anchor/dist/cjs/utils/token");
const spl_token_1 = require("@solana/spl-token");
const banxAdventure_1 = require("../banxAdventure");
const helpers_2 = require("./helpers");
const common_1 = require("../../../../common");
const mpl_token_metadata_1 = require("@metaplex-foundation/mpl-token-metadata");
const stakeBanxNft = ({ programId, connection, addComputeUnits, priorityFees, accounts, optimistics, sendTxn, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const program = (0, helpers_1.returnAnchorProgram)(programId, connection);
    const instructions = [];
    const [banxStakingSettings] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_STAKING_SETTINGS_PREFIX)], program.programId);
    const [banxStakingVault] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_STAKING_VAULT_PREFIX)], program.programId);
    const [banxTokenStake] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_TOKEN_STAKE_PREFIX), accounts.userPubkey.toBuffer()], program.programId);
    const banxStake = anchor_1.web3.Keypair.generate();
    const modifyComputeUnits = anchor_1.web3.ComputeBudgetProgram.setComputeUnitLimit({
        units: Math.round(800000 + Math.ceil(Math.random() * 10000)),
    });
    const requestHeap = anchor_1.web3.ComputeBudgetProgram.setComputeUnitPrice({ microLamports: priorityFees });
    instructions.push(requestHeap);
    if (!!addComputeUnits)
        instructions.push(modifyComputeUnits);
    const currentWeek = (0, banxAdventure_1.banxAdventureTimestampToWeeks)((0, helpers_1.nowInSeconds)());
    const [firstWeekBanxAdventure] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_ADVENTURE_PREFIX), constants_1.ENCODER.encode((0, banxAdventure_1.weeksToBanxAdventureTimestamp)(currentWeek + 1).toString())], program.programId);
    const [secondWeekBanxAdventure] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_ADVENTURE_PREFIX), constants_1.ENCODER.encode((0, banxAdventure_1.weeksToBanxAdventureTimestamp)(currentWeek + 2).toString())], program.programId);
    const [firstWeekBanxAdventureSubscription] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_ADVENTURE_SUBSCRIPTION_PREFIX), firstWeekBanxAdventure.toBuffer(), accounts.userPubkey.toBuffer()], program.programId);
    const [secondWeekBanxAdventureSubscription] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_ADVENTURE_SUBSCRIPTION_PREFIX), secondWeekBanxAdventure.toBuffer(), accounts.userPubkey.toBuffer()], program.programId);
    const weeks = [currentWeek + 1, currentWeek + 2];
    const subscribeBanxAdventureParams = (yield Promise.all(weeks.map((week) => __awaiter(void 0, void 0, void 0, function* () {
        const [adventure, adventureBump] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_ADVENTURE_PREFIX), constants_1.ENCODER.encode((0, banxAdventure_1.weeksToBanxAdventureTimestamp)(week).toString())], program.programId);
        const [adventureSubscription, adventureSubscriptionBump] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_ADVENTURE_SUBSCRIPTION_PREFIX), adventure.toBuffer(), accounts.userPubkey.toBuffer()], program.programId);
        const params = {
            week: new anchor_1.BN(week),
            adventureBump: adventureBump,
            subscriptionBump: adventureSubscriptionBump
        };
        return params;
    })))).flat();
    const userTokenAccount = yield (0, common_1.findAssociatedTokenAddress)(accounts.userPubkey, accounts.tokenMint);
    const editionInfo = (0, helpers_1.getMetaplexEditionPda)(accounts.tokenMint);
    const nftMetadata = (0, helpers_1.getMetaplexMetadata)(accounts.tokenMint);
    const ownerTokenRecord = (0, helpers_1.findTokenRecordPda)(accounts.tokenMint, userTokenAccount);
    const [banxPointsMap] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_POINTS_MAP_PREFIX), accounts.tokenMint.toBuffer()], program.programId);
    const meta = yield mpl_token_metadata_1.Metadata.fromAccountAddress(connection, nftMetadata);
    const ruleSet = (_a = meta.programmableConfig) === null || _a === void 0 ? void 0 : _a.ruleSet;
    const tokenRecordData = meta.tokenStandard === mpl_token_metadata_1.TokenStandard.ProgrammableNonFungible
        ? yield mpl_token_metadata_1.TokenRecord.fromAccountAddress(connection, ownerTokenRecord)
        : { delegate: null };
    const delegatePubkey = tokenRecordData.delegate;
    const accountsIntoInstruction = {
        banxStakingSettings,
        banxTokenStake: banxTokenStake,
        user: accounts.userPubkey,
        systemProgram: anchor_1.web3.SystemProgram.programId,
        rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
        instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
        authorizationRulesProgram: constants_1.AUTHORIZATION_RULES_PROGRAM,
        metadataProgram: constants_1.METADATA_PROGRAM_PUBKEY,
        editionInfo: editionInfo,
        banxStake: banxStake.publicKey,
        banxPointsMap,
        tokenMint: accounts.tokenMint,
        userTokenAccount,
        hadoRegistry: accounts.hadoRegistry,
        whitelistEntry: accounts.whitelistEntry,
        banxStakingVault,
        nftMetadata,
        ownerTokenRecord,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        associatedTokenProgram: token_1.ASSOCIATED_PROGRAM_ID,
        firstWeekBanxAdventure,
        secondWeekBanxAdventure,
        firstWeekBanxAdventureSubscription,
        secondWeekBanxAdventureSubscription,
    };
    const remainingAccountsPnft = [
        {
            pubkey: ruleSet || constants_1.METADATA_PROGRAM_PUBKEY,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: delegatePubkey || constants_1.METADATA_PROGRAM_PUBKEY,
            isSigner: false,
            isWritable: false,
        },
    ];
    instructions.push(yield program.methods
        .stakeBanxNft(subscribeBanxAdventureParams)
        .accountsStrict(accountsIntoInstruction)
        .remainingAccounts(remainingAccountsPnft)
        .instruction());
    const transaction = new anchor_1.web3.Transaction();
    for (let instruction of instructions)
        transaction.add(instruction);
    const signers = [banxStake];
    yield sendTxn(transaction, signers);
    const optimisticBanxStake = (0, helpers_2.optimisticInitializeBanxStake)({
        banxPointsMap: optimistics.banxPointsMap,
        banxStakeKey: banxStake.publicKey.toBase58(),
        userKey: accounts.userPubkey.toBase58(),
        nftMint: accounts.tokenMint.toBase58(),
        collateralTokenAccount: userTokenAccount.toBase58(),
    });
    const optimisticAddBanxTokensStake = (0, helpers_2.optimisticAddNftToBanxTokensStake)({
        banxStake: optimisticBanxStake.banxStake,
        banxTokensStake: optimistics.banxSubscribeAdventureOptimistic.banxTokenStake ? Object.assign({}, optimistics.banxSubscribeAdventureOptimistic.banxTokenStake) : (0, helpers_2.optimisticInitializeBanxTokenStake)({
            user: accounts.userPubkey,
        }).banxTokensStake,
        banxStakingSettings: Object.assign({}, optimistics.banxSubscribeAdventureOptimistic.banxStakingSettings)
    });
    const optimisticResult = yield (0, banxAdventure_1.subscribeBanxAdventrueOptimistics)({
        banxStakingSettings: optimisticAddBanxTokensStake.banxStakingSettings,
        banxTokenStake: optimisticAddBanxTokensStake.banxTokensStake,
        banxAdventures: optimistics.banxSubscribeAdventureOptimistic.banxAdventures
    }, weeks, true);
    return {
        instructions,
        signers,
        optimisticResult,
    };
});
exports.stakeBanxNft = stakeBanxNft;
